export const Drawable = {

    appIcon: require("./app_icon.png"),
    sdeskAndroidScreen: require("./sdesk_screenshot_withframe_android.png"),
    sdeskIosScreen: require("./sdesk_screenshot_withframe_ios.png"),
    sdeskBoothScreen: require("./sdesk_screenshot_withframe_booth.png"),
    androidLogo: require("./android_logo.png"),
    iOSLogo: require("./ios_logo.png"),
    close: require("./close.png"),

    quickGuide: {
        default: require("./quickGuide/default.jpg"),
        login: {
            empty: require("./quickGuide/login/quick_guide_login1.jpg"),
            filled: require("./quickGuide/login/quick_guide_login2.jpg")
        },
        createReservation: {
            list: require("./quickGuide/reservationList/create_reservation_list.jpg"),
            empty: require("./quickGuide/createDeclaration/create_reservation_home.jpg"),
            selectStartDate: require("./quickGuide/createDeclaration/create_reservation_select_start_date.jpg"),
            selectEndDate: require("./quickGuide/createDeclaration/create_reservation_select_stop_date.jpg"),
            selectFractionTime: require("./quickGuide/createDeclaration/create_reservation_select_fraction_time.jpg"),
            selectOffice: require("./quickGuide/createDeclaration/create_reservation_select_office.jpg"),
            selectFloor: require("./quickGuide/createDeclaration/create_reservation_select_floor.jpg"),
            selectRoom: require("./quickGuide/createDeclaration/create_reservation_select_room.jpg"),
            selectDesk: require("./quickGuide/createDeclaration/create_reservation_select_desk.jpg"),
            filled: require("./quickGuide/createDeclaration/create_reservation_home_filled.jpg"),
        },
        confirmReservation: {
            list: require("./quickGuide/reservationList/create_reservation_list.jpg"),
            reservationDetail: require("./quickGuide/confirmReservation/reservation_detail.jpg"),
            subreservationDetail: require("./quickGuide/confirmReservation/subreservation_detail.jpg"),
            scanQrcode: require("./quickGuide/confirmReservation/scan_qrcode.jpg"),
        },
        closeReservation: {
            list: require("./quickGuide/reservationList/create_reservation_list.jpg"),
            reservationDetail: require("./quickGuide/closeReservation/reservation_detail.jpg"),
            subreservationDetail: require("./quickGuide/closeReservation/subreservation_detail.jpg"),
        }

    },

    getProperty(property: string, object: any): string {
        let properties = property.split(".")
        if (properties.length === 1) {
            console.log("*")
            return object[property]
        } else {
            let newObject = object[properties[0]]
            let newProperty = property.replace(properties[0] + ".", "")
            return this.getProperty(newProperty, newObject)
        }
    },


    get(screen: string) {
        return this.getProperty(screen, Drawable);
    }
}
